export default "__VITE_ASSET__C4wENq5L__"